export const unheardQuest = {
  id: 'unheard',
  titleKey: 'chapter_unheard',
  shortName: 'UNHRD',
  date: '16.11.2025',
  status: 'active',
  questMap: [
    // --- 1. HOW TO START THE QUEST ---
    {
      id: 'step_start',
      label: {
          en: "How to start the quest",
          tr: "Görevi nasıl başlatırsın",
          ru: "Как начать квест"
      },
      type: 'start',
      isSubTask: false,
      details: {
        location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
        requiredItems: null,
        warning: {
          en: "If you activated this quest while progressing through other (story) quests, you still must pick up the note on Streets of Tarkov. Otherwise, all subsequent stages of this quest will bug out, and documents and notes will not spawn for you.",
          tr: "Bu görevi başka görevler ile ilerlerken aynı esnada başlattıysanız, notu tekrardan almanız gerekebilir. Aksi takdirde bu görevin sonraki aşamaları bozulacak ve belgeler ve notlar haritada gözükmeyecektir.",
          ru: "Даже если вы взяли этот квест, пока шли по другим сюжетным заданиям — всё равно не забудьте поднять записку на «Улицах Таркова». Если не поднимете — дальше всё поломается: документы и записки просто не заспавнятся. "
        },
        objective: {
          en: "Find and pick up the note left in the TerraGroup office on Streets of Tarkov.",
          tr: "Streets of Tarkov'daki TerraGroup ofisinde bırakılan notu bul ve al.",
          ru: "Найдите и подберите записку в офисе TerraGroup на Улицах Таркова."
        },
        story: {
          en: "\"I came across a strange note on a TerraGroup sheet. It mentions the will of The Unheard and some fuel needed for 'Purification'. TerraGroup's definitely involved with this, and I should gather more information about The Unheard. For starters, I need to figure out this fuel. Looks like TerraGroup Labs are behind it.\"",
          tr: "\"TerraGroup dosyalarında garip bir notla karşılaştım. Not, İşitilmeyenler'in iradesinden ve 'Arındırma' için gereken bir yakıttan bahsediyor. TerraGroup kesinlikle bunun içine karışmış ve İşitilmeyenler hakkında daha fazla bilgi toplamam gerekiyor. İlk olarak bu yakıtın ne olduğunu çözmeliyim. Görünüşe göre TerraGroup Laboratuvarları bunun arkasında.\"",
          ru: "\"Я нашёл странную записку на бланковом листе TerraGroup. В ней говорится о воле Неизвестных и топливе, которое нужно для «очищения». TerraGroup как-то связаны с этим, и мне стоит поискать больше информации насчёт этих Неизвестных. Для начала стоит найти больше информации о топливе. Похоже на работу TerraGroup Labs.\""
        },
        guideSteps: [
          {
            text: {
              en: "Go to Streets of Tarkov. The note is on a desk in the TerraGroup office (Klimov Street), room with monitors.",
              tr: "Streets of Tarkov'a git. Not, TerraGroup ofisinde (Klimov Caddesi), monitörlerin olduğu odada masanın üzerinde.",
              ru: "Идите на Улицы Таркова. Записка лежит на столе в офисе TerraGroup."
            },
            images: ['/Story/Unheard/Step1.webp', '/Story/Unheard/Step1-1.webp', '/Story/Unheard/Step1-2.webp']
          }
        ]
      }
    },

    // --- 2. FIND MORE INFO ABOUT TERRAGROUP ACTIVITY ---
    {
      id: 'step_tg_activity',
      label: {
          en: "Find more info about TerraGroup activity",
          tr: "TerraGroup faaliyetleri hakkında daha fazla bilgi bul",
          ru: "Найти больше информации о деятельности TerraGroup"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "The Lab", tr: "Laboratuvar", ru: "Лаборатория" },
        requiredItems: null,
        warning: null,
        objective: {
          en: "Search for documents in The Lab (Dark Office & Laboratory in middle of the map).",
          tr: "The Lab (Laboratuvar) haritasında belgeleri ara (Karanlık Ofis & Laboratuvar).",
          ru: "Найдите документы в Лаборатории (Темный кабинет и лаборатория в центре карты)."
        },
        story: {
          en: "\"The note pointed towards the Labs. To understand what 'Purification' means, I need to dig into TerraGroup's confidential activities in the Laboratory sector.\"",
          tr: "\"Not Laboratuvarı işaret ediyordu. 'Arındırma'nın ne anlama geldiğini anlamak için TerraGroup'un Laboratuvar sektöründeki gizli faaliyetlerini araştırmam gerekiyor.\"",
          ru: "\"Записка указывала на Лабораторию. Чтобы понять, что означает «Очищение», мне нужно изучить конфиденциальную деятельность TerraGroup...\""
        },
        guideSteps: [
          {
            text: {
              en: "First document: 2nd floor Dark Office, next to Green Keycard room.",
              tr: "İlk belge: 2. kat Karanlık Ofis, Yeşil Kart ile açılan odanın yanı.",
              ru: "Первый документ: 2 этаж, Темный кабинет, рядом с комнатой с зелёной ключ-картой."
            },
            images: ['/Story/Unheard/Step2-smallstep1-1.webp', '/Story/Unheard/Step2-smallstep1-2.webp']
          },
          {
            text: {
              en: "Second document: Nearby, one floor below, in the free-access room on a table.",
              tr: "İkinci belge: Yakınlarda, bir alt katta, herkesin girebildiği odada masanın üzerinde.",
              ru: "Второй документ: рядом, на этаж ниже — в комнате со свободным доступом (на столе)."
            },
            images: ['/Story/Unheard/Step2-smallstep2-1.webp', '/Story/Unheard/Step2-smallstep2-2.webp']
          }
        ]
      }
    },

    // --- 3. FIND MORE INFO ABOUT SPECIAL CATALYST SHIPMENT ---
    {
      id: 'step_catalyst',
      label: {
          en: "Find more information about the special catalyst shipment",
          tr: "Özel katalizatör sevkiyatı hakkında daha fazla bilgi bul",
          ru: "Найти больше информации о специальной поставке катализатора"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Factory", tr: "Fabrika", ru: "Завод" },
        requiredItems: null,
        warning: null,
        objective: {
          en: "Search for clues in the Factory location (Medical Tent area).",
          tr: "Factory (Fabrika) bölgesinde ipuçları ara (Tıbbi Çadır alanı).",
          ru: "Ищите улики на локации «Завод» (район Медпалатки)."
        },
        story: {
          en: "\"At the factory, I managed to find a manual with handwritten notes. The Blue Ice shipment left at the factory was clearly a big deal for TerraGroup or The Unheard. They planned to move it in first priority.\"",
          tr: "\"Fabrikada, üzerinde el yazısı notlar olan bir el kitabı bulmayı başardım. Fabrikada bırakılan 'Mavi Buz' sevkiyatı, TerraGroup veya İşitilmeyenler için açıkça büyük bir meseleydi. Onu öncelikli olarak taşımayı planlamışlar.\"",
          ru: "\"На заводе мне удалось найти инструкцию с пометками от руки. Груз Голубого льда... был явно чем-то очень важным...\""
        },
        guideSteps: [
          {
            text: {
              en: "Medical Tent hall. Look for two large blue tanks; document is on a yellow barrel next to them.",
              tr: "Tıbbi çadır holü. İki büyük mavi tankı ara; belge yanlarındaki sarı varilin üzerinde.",
              ru: "Холл Медпалатки. Ищите два больших синих баллона — документ лежит на жёлтом бочонке рядом с ними."
            },
            images: ['/Story/Unheard/Step3.webp', '/Story/Unheard/Step3-1.webp']
          }
        ]
      }
    },

    // --- 4. RETRIEVE DATA FROM RZHEVSKY'S CAR ---
    {
      id: 'step_rzhevsky',
      label: {
          en: "Retrieve the data from Rzhevsky's car",
          tr: "Rzhevsky'nin arabasından veriyi al",
          ru: "Забрать данные из машины Ржевского"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
        requiredItems: null,
        warning: null,
        objective: {
          en: "Find Rzhevsky's car on Streets of Tarkov and retrieve the HDD.",
          tr: "Streets of Tarkov'da Rzhevsky'nin arabasını bul ve HDD'yi al.",
          ru: "Найдите машину Ржевского на Улицах Таркова и заберите HDD."
        },
        story: {
          en: "\"In Rzhevsky's service car, I might find a hard drive containing vital info. I need to take it back to my Intel Center, download the data and see what's on it.\"",
          tr: "\"Rzhevsky'nin hizmet aracında hayati bilgiler içeren bir sabit disk bulabilirim. Onu İstihbarat Merkezime götürüp verileri indirmeli ve içinde ne olduğuna bakmalıyım.\"",
          ru: "\"В служебной машине Ржевского я смог найти жёсткий диск. Нужно отнести его в Разведцентр...\""
        },
        guideSteps: [
          {
            text: {
              en: "Locate the grey G-Wagen near LeXoS dealership (Primorsky Ave). Plate: 0456МГ-78. Grab HDD.",
              tr: "Primorsky Caddesi, LeXoS galerisi yanındaki gri G-Wagen'i bul plakası (0456МГ-78). HDD'yi al.",
              ru: "Нас интересует автомобиль G-wagen с номерным знаком 0456МГ- 78, серого цвета. Заберите HDD."
            },
            images: ['/Story/Unheard/Step4.webp', '/Story/Unheard/Step4-1.webp', '/Story/Unheard/Step4-2.webp']
          }
        ]
      }
    },

    // --- 5. FIND INFORMATION ABOUT BLUE ICE ---
    {
      id: 'step_blue_ice',
      label: {
          en: "Find information about Blue Ice",
          tr: "Blue Ice hakkında bilgi bul",
          ru: "Найти информацию о Голубом льде"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Factory (Locked Room)", tr: "Fabrika (Kilitli Oda)", ru: "Завод (Запертая комната)" },
        requiredItems: [
          {
            en: "Polikhim/Cultist Keycard",
            tr: "Polikhim/Cultist Anahtar Kartı",
            ru: "Ключ-карта Полихима",

          }
        ],
        warning: null,
        objective: {
          en: "Find info about 'Blue Ice' in the locked room on Factory.",
          tr: "Factory (Fabrika) haritasındaki kilitli odada 'Blue Ice' hakkında bilgi bul.",
          ru: "Найдите информацию о 'Голубом льде' в закрытой комнате на Заводе."
        },
        story: {
          en: "\"The decryption of the drive mentions the 'closed part of Polikhim'. It seems they were storing the Blue Ice samples there specifically for the cult's operations.\"",
          tr: "\"Sürücünün şifresinin çözülmesi 'Polikhim'in kapalı bölümünden' bahsediyor. Görünüşe göre Mavi Buz örneklerini özellikle tarikatın operasyonları için orada saklıyorlarmış.\"",
          ru: "\"Расшифровка упоминает закрытую часть Полихима. Похоже, там хранили образцы Голубого льда...\""
        },
        guideSteps: [
          {
            text: {
              en: "Go to Factory new area. Open the locked room with the card.",
              tr: "Fabrika'nın yeni bölgesine (bodrum) git. Kart ile kilitli odayı aç.",
              ru: "Идите в подвал Завода. Откройте комнату картой."
            },
            images: ['/Story/Unheard/Step5polikhim.webp', '/Story/Unheard/Step5.webp', '/Story/Unheard/Step5-1.webp', '/Story/Unheard/Step5-1-1.webp']
          }
        ]
      }
    },

    // --- 6. SEARCH FOR MENTIONS OF A.P. IN THE LABORATORY ---
    {
      id: 'step_ap_lab',
      label: {
          en: "Search for mentions of A.P. in the Laboratory",
          tr: "Laboratuvar'da A.P. hakkında ipucu ara",
          ru: "Искать упоминания А.П. в Лаборатории"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "The Lab", tr: "Laboratuvar", ru: "Лаборатория" },
        requiredItems: [
          { en: "Voice Recorder (Recommended)", tr: "Ses Kayıt Cihazı (Önerilir)", ru: "Диктофон (Рекомендуется)" }
        ],
        warning: {
          en: "IMPORTANT: Make sure to listen to the tapes you find.",
          tr: "ÖNEMLİ: Bulduğun kasetleri dinlemeyi unutma.",
          ru: "ВАЖНО: Обязательно прослушайте найденные записи."
        },
        story: {
          en: "\"The trail leads back to the Labs. I need to find who 'A.P.' is. He seems to be a key figure orchestrating the logistics between TerraGroup and The Unheard.\"",
          tr: "\"İzler tekrar Laboratuvara çıkıyor. 'A.P.'nin kim olduğunu bulmalıyım. TerraGroup ile İşitilmeyenler arasındaki lojistiği yöneten kilit bir figür gibi görünüyor.\"",
          ru: "\"Следы ведут обратно в Лабораторию. Мне нужно узнать, кто такой А.П...\""
        },
        objective: {
          en: "Search for mentions of 'A.P.' in The Lab .",
          tr: "The Lab haritasında 'A.P.' hakkındaki izleri ara.",
          ru: "Ищите упоминания об А.П. в Лаборатории."
        },
        guideSteps: [
          {
            text: {
              en: "Admin Office: Check sticky notes. Second Floor.",
              tr: "Admin Ofisi: Notları kontrol et. İkinci kat.",
              ru: "Офис Молекула: Проверьте стикеры. Второй этаж."
            },
            images: ['/Story/Unheard/Step6-smallstep1-1.webp', '/Story/Unheard/Step6-smallstep1-2.webp']
          },
          {
            text: {
              en: "Lecture Hall: Find Audio Cassette #2 (table) & #1 (floor).",
              tr: "Derslik: Kaset #2 (masa) ve #1 (yer) bul.",
              ru: "Лекционный зал: Найдите кассеты."
            },
            images: ['/Story/Unheard/Step6-smallstep2-1.webp', '/Story/Unheard/Step6-smallstep2-2.webp', '/Story/Unheard/Step6-smallstep2-3.webp']
          }
        ]
      }
    },

    // --- 7. FIND A.P.'S ROOM ON RESORT ---
    {
      id: 'step_ap_resort',
      label: {
          en: "Find A.P.'s room on Resort",
          tr: "Resort'ta A.P.'nin odasını bul",
          ru: "Найти комнату А.П. в Санатории"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Shoreline (Resort)", tr: "Kıyı Şeridi (Resort)", ru: "Берег (Санаторий)" },
        requiredItems: null,
        warning: null,
        objective: {
          en: "Find A.P.'s room in Resort (East Wing Room 305).",
          tr: "Resort haritasında A.P.'nin odasını bul (Doğu Kanadı Oda 305).",
          ru: "Найдите комнату А.П. в Санатории (Восточное крыло 305)."
        },
        story: {
          en: "\"Intelligence indicates A.P. was staying at the Health Resort. Room 305 in the East Wing. He might have left encryption keys or personal notes there.\"",
          tr: "\"İstihbarat, A.P.'nin Sağlık Tatil Köyü'nde (Resort) kaldığını gösteriyor. Doğu Kanadı, Oda 305. Orada şifreleme anahtarları veya kişisel notlar bırakmış olabilir.\"",
          ru: "\"Разведданные указывают, что А.П. останавливался в Санатории...\""
        },
        guideSteps: [
          {
            text: {
              en: "Go to East Wing 305 (No key needed). Collect: 1) Flash drive, 2) Note.",
              tr: "Doğu 305'e git (Anahtar gerekmez). Topla: 1) Flash bellek, 2) Not.",
              ru: "Идите в Восточное крыло 305. Заберите флешку и записку."
            },
            images: ['/Story/Unheard/Step7.webp', '/Story/Unheard/Step7-1.webp']
          }
        ]
      }
    },

    // --- 8. DECRYPT THE FLASH DRIVE FROM A.P.'S ROOM ---
    {
      id: 'step_decrypt',
      label: {
          en: "Decrypt the flash drive from A.P.'s room",
          tr: "A.P.'nin odasındaki flash belleğin şifresini çöz",
          ru: "Расшифровать флешку из комнаты А.П."
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
        requiredItems: [
          { en: "5,000,000 Rubles", tr: "5.000.000 Ruble", ru: "5 000 000 Рублей" },
          { en: "Virtex Processor", tr: "Virtex İşlemci", ru: "Процессор Virtex" },
          { en: "Intel Center Lvl 1", tr: "İstihbarat Merkezi Sv. 1", ru: "Разведцентр Уровень 1" }
        ],
        warning: {
          en: "Wait ~1 hour for the next quest. If craft doesn't appear, restart game.",
          tr: "Sonraki görev için ~1 saat beklemen gerekir. Craft görünmezse oyuna reset at.",
          ru: "Вам придется подождать около 1 часа. Если крафт не появился, перезапустите игру."
        },
        story: {
          en: "\"The flash drive from the Resort is heavily encrypted. I need to use the Intel Center's processing power to crack it. This will take time and resources.\"",
          tr: "\"Resort'tan alınan flash bellek ağır şifrelenmiş. Kırmak için İstihbarat Merkezi'nin işlem gücünü kullanmalıyım. Bu zaman ve kaynak alacak.\"",
          ru: "\"Флешка из Санатория надежно зашифрована...\""
        },
        objective: {
          en: "Decrypt the flash drive in Hideout via Intel Center.",
          tr: "Sığınak'ta (Hideout) Intel Center üzerinden flash belleğin şifresini çöz.",
          ru: "Расшифруйте флешку в Убежище."
        },
        guideSteps: [
          {
            text: {
              en: "Start decryption craft in Intel Center. Wait 12h. Hand over the drive and pay 5M Rubles.",
              tr: "Intel Center'da şifre çözmeyi başlat. 12s bekle. Sürücüyü ver ve 5M Ruble öde.",
              ru: "Запустите расшифровку в Разведцентре."
            },
            images: []
          }
        ]
      }
    },

    // --- 9. INTEGRATE THE DATA (YENİ EKLENEN ADIM) ---
    {
      id: 'step_integrate',
      label: {
          en: "Integrate the data from A.P.'s flash drive into the TerraGroup network",
          tr: "A.P.'nin flash belleğindeki verileri TerraGroup ağına entegre et",
          ru: "Интегрировать данные с флешки А.П. в сеть TerraGroup"
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Menu / Hideout", tr: "Menü / Sığınak", ru: "Меню / Убежище" },
        requiredItems: null,
        warning: null,
        objective: {
          en: "Complete the data integration in the quest menu.",
          tr: "Görev menüsünden veri entegrasyonunu tamamla.",
          ru: "Завершите интеграцию данных в меню квеста."
        },
        story: {
          en: "\"Decryption complete. Now, to trigger the final protocol and find the main target, I must upload this data into the TerraGroup network disguised as a system update.\"",
          tr: "\"Şifre çözme tamamlandı. Şimdi, son protokolü tetiklemek ve ana hedefi bulmak için bu verileri bir sistem güncellemesi kılığında TerraGroup ağına yüklemeliyim.\"",
          ru: "\"Расшифровка завершена. Теперь, чтобы запустить финальный протокол...\""
        },
        guideSteps: [
          {
            text: {
              en: "Click 'Complete' in the trader menu after the decryption and payment are finished.",
              tr: "Şifre çözme ve ödeme bittikten sonra tüccar menüsünden 'Tamamla'ya tıkla.",
              ru: "Нажмите 'Завершить' в меню торговца."
            },
            images: []
          }
        ]
      }
    },

    // --- 10. VISIT A.P.'S SERVICE APARTMENT (FİNAL) ---
    {
      id: 'step_service_apt',
      label: {
          en: "Visit A.P.'s service apartment",
          tr: "A.P.'nin hizmet dairesini ziyaret et",
          ru: "Посетить служебную квартиру А.П."
      },
      type: 'objective',
      isSubTask: false,
      details: {
        location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
        requiredItems: [
          { en: "TerraGroup Corporate Apartment Key", tr: "TerraGroup Kurumsal Daire Anahtarı", ru: "Ключ от корпоративной квартиры TerraGroup" },
          { en: "Green Keycard (Crafted)", tr: "Yeşil Keycard (Üretilmiş)", ru: "Зеленая ключ-карта" }
        ],
        warning: {
          en: "BUG ALERT: Secret door prompt might be missing. Try moving/crouching. Only 'Green Keycard' craft works!",
          tr: "BUG UYARISI: Gizli kapı yazısı çıkmayabilir. Hareket etmeyi dene. Sadece 'Yeşil Keycard' craftı çalışır!",
          ru: "БАГ: Надпись может не появиться. Работает только крафт 'Зеленой карты'!"
        },
        objective: {
          en: "Visit A.P.'s service apartment in the Cardinal complex (Streets).",
          tr: "Streets'teki Cardinal kompleksinde bulunan A.P.'nin hizmet dairesine git.",
          ru: "Посетите служебную квартиру А.П. в комплексе Кардинал."
        },
        story: {
          en: "\"I followed the trail of high-ranking TerraGroup people and discovered far more than I intended. The corporation turned out to be just one of the tools in the hands of The Unheard. It seems the entire Tarkov conflict was planned and executed according to their design.\"",
          tr: "\"Üst düzey TerraGroup yetkililerinin izini sürdüm ve umduğumdan çok daha fazlasını keşfettim. Şirket, planları hiç de iyi niyetli olmayan İşitilmeyenler'in elindeki araçlardan sadece biriymiş. Görünüşe göre tüm Tarkov çatışması onların tasarımına göre planlanmış ve uygulanmış.\"",
          ru: "\"Я прошёл по следам высокоранговых сотрудников из TerraGroup и нашёл куда больше, чем хотел бы...\""
        },
        guideSteps: [
          {
            text: {
              en: "Streets: Cardinal Complex. Open main door with Apartment Key. Enter walk-in closet.",
              tr: "Streets: Cardinal Kompleksi. Ana kapıyı anahtarla aç. Giyinme odasına gir.",
              ru: "Идите в Кардинал. Откройте дверь. Зайдите в гардероб."
            },
            images: ['/Story/Unheard/Step-10-2.webp', '/Story/Unheard/Step-10-1.webp', '/Story/Unheard/Step-10-3.webp', '/Story/Unheard/Step-10-4.webp']
          },
          {
            text: {
              en: "Use Green Keycard on the wall. Collect 4 docs inside to FINISH the quest.",
              tr: "Duvarda Yeşil Kartı kullan. İçerideki 4 belgeyi topla ve görevi BİTİR.",
              ru: "Используйте зеленую карту. Соберите 4 документа."
            },
            images: ['/Story/Unheard/Step-10.webp']
          }
        ]
      }
    }
  ]
};